import { Action, createReducer, on } from '@ngrx/store';
import { AppointmentRequestQuery } from '@warema/shared/models';
import * as AppointmentMetadataActions from './appointment-metadata.actions';

export interface AppointmentMetadataState {
    appointmentRequestQuery: AppointmentRequestQuery | null;
}

const initialState: AppointmentMetadataState = {
    appointmentRequestQuery: null,
};

const appointmentMetadataReducer = createReducer(
    initialState,
    on(
        AppointmentMetadataActions.SetAppointmentRequestQuery,
        (state, { appointmentRequestQuery }): AppointmentMetadataState => ({ ...state, appointmentRequestQuery }),
    ),
);

export function reducer(state: AppointmentMetadataState, action: Action): AppointmentMetadataState {
    return appointmentMetadataReducer(state, action);
}
